// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3dFPb","requiredAsterisk":"Info_requiredAsterisk__3oN1d"};